import { createAction } from '@reduxjs/toolkit';

export const fetchCaseStudies = createAction('caseStudies/fetchCaseStudies');
export const fetchCaseStudy = createAction('caseStudies/fetchCaseStudy', (caseStudyId) => ({ payload: { caseStudyId } }));
export const setCaseStudiesSuccess = createAction('caseStudies/setCaseStudiesSuccess');
export const setCaseStudySuccess = createAction('caseStudies/setCaseStudySuccess');
export const setCaseStudiesError = createAction('caseStudies/setCaseStudiesError');
